import React, { Component } from "react";
import eventStyles from "./EventAdministration.module.scss";
import { withTranslation } from "react-i18next";
import VehicleCatalogClient from "../../../../shared/clients/VehicleCatalogClient";
import BackToButton from "../../../../shared/backToButton/BackToButton";
import SubNav from "../../../../shared/subnav/SubNav";
import { logMsg } from "../../../../common/Logger";
import {
  displayError,
  isUnknownError,
  PAGE_ERROR,
} from "../../../../errors/ErrorConstants";
import {
  DropDownContainer,
  TableHeader,
  TableCell,
} from "./EventAdministration.component";
import PricingClient from "../../../../shared/clients/PricingClient";
import { MarketGroups } from "../../../../shared/marketGroups/MarketGroups";
import UiDateUtils from "../../../../utils/UiDateUtils";
import HasPermissionTo from "../../../../common/HasPermissionTo";

class EventAdministration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: [],
      catalogIds: [],
      modelData: null,
      yearDropDownValues: [],
      selectedModel: null,
      selectedYear: null,
      preferences: [],
      savedOptionsPriceEvent: null,
      optionsPriceEvent: null,
    };

    this.eventTypeNames = {
      isNewModel: this.props.t("New Model Year*"),
      gpi: this.props.t("PricingWrapper.gpi"),
      tax: this.props.t("PricingWrapper.tax"),
      vm: this.props.t("PricingWrapper.vm"),
      adjustmentChange: this.props.t("PricingWrapper.adjustmentChange"),
      adjustmentExtension: this.props.t("PricingWrapper.adjustmentExtension"),
    };
  }

  componentDidMount() {
    this.fetchVehicleLines();
  }

  onCatalogChange = (catalogIds) => {
    const currentPreference =
      this.state.preferences?.filter(
        (preference) =>
          preference.catalog === (catalogIds || this.state.catalogIds)?.[0]
      )?.[0] || null;

    let _optionsPriceEvent = null;
    if (currentPreference) {
      _optionsPriceEvent = {};
      for (const name of Object.keys(this.eventTypeNames)) {
        _optionsPriceEvent[name] = {
          desc: this.eventTypeNames[name],
          selectedIndex: currentPreference[name] || 1,
        };
      }
    }
    this.setState({
      savedOptionsPriceEvent: _optionsPriceEvent,
      optionsPriceEvent: _optionsPriceEvent,
      updatedBy: currentPreference?.updatedBy,
      updatedAt: currentPreference?.updatedAt,
    });
  };

  onModelChange = (event) => {
    if (event) {
      event.preventDefault();
    }
    const maxYear = this.getYears(this.state.modelData, event.target.value);

    const catalogIds =
      this.state.modelData &&
      this.state.modelData
        .filter(
          (x) =>
            x.model === event.target.value &&
            x.year.toString() === maxYear.toString()
        )
        .map((model) => model.catalogId && model.catalogId.toString());

    this.onCatalogChange(catalogIds);
    this.setState(
      {
        selectedModel: event.target.value,
        selectedYear: maxYear,
        catalogIds,
      },
      () => {}
    );
  };

  onYearChange = (event) => {
    const catalogIds = this.getCatalogId(
      this.state.selectedModel,
      event.target.value
    );
    this.onCatalogChange(catalogIds);
    this.setState(
      {
        selectedYear: event.target.value,
        catalogIds,
      },
      () => {}
    );
  };

  onPriceEventOptionChange = (event, optionIndex) => {
    this.setState({
      optionsPriceEvent: Object.assign({}, this.state.optionsPriceEvent, {
        [event.target.name]: {
          desc: this.state.optionsPriceEvent[event.target.name].desc,
          selectedIndex: optionIndex + 1,
        },
      }),
    });
  };

  onSaveChanges = () => {
    const options = Object.keys(this.eventTypeNames)
      .slice(1)
      .map((type) => this.state.optionsPriceEvent[type].selectedIndex);
    this.props.hideOrShow(true);
    PricingClient.saveNscPreference(
      this.props.user,
      this.state.catalogIds[0],
      options
    )
      .then(() => {
        const _preferences = Object.assign([], this.state.preferences);
        const currentIndex = _preferences.findIndex(
          (pref) => pref.catalog === this.state.catalogIds[0]
        );
        for (const type of Object.keys(this.eventTypeNames).slice(1))
          _preferences[currentIndex][type] =
            this.state.optionsPriceEvent[type].selectedIndex;
        _preferences[currentIndex].updatedBy = this.props.user.userId;
        const currentDate = new Date();
        _preferences[currentIndex].updatedAt = UiDateUtils.formatDateYYYYMMDD(
          currentDate.getFullYear(),
          currentDate.getMonth() + 1,
          currentDate.getDate()
        );
        this.setState({
          savedOptionsPriceEvent: this.state.optionsPriceEvent,
          preferences: _preferences,
          updatedBy: _preferences[currentIndex].updatedBy,
          updatedAt: _preferences[currentIndex].updatedAt,
        });
      })
      .catch((error) => {
        logMsg("reason", error);
        if (isUnknownError(error)) {
          this.setState({ hasError: [PAGE_ERROR] });
        }
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  onMarketChange = (event) => {
    event.preventDefault();
    const market = event.target.value;
    this.props.updateCurrentMarket(market);
    this.fetchVehicleLines();
  };

  getCatalogId = (selectedModel, selectedYear) => {
    const catalogIds = [];
    if (selectedYear !== null && selectedModel !== null) {
      this.state.modelData &&
        this.state.modelData.forEach((vehicleLine) => {
          if (
            vehicleLine.model === selectedModel &&
            vehicleLine.year.toString() === selectedYear.toString()
          ) {
            catalogIds.push(vehicleLine.catalogId);
          }
        });

      this.setState({ catalogIds });
    }
    return catalogIds;
  };

  getDefaultModel = (vehicleLines) => {
    const models = vehicleLines.map((vehicleLine) => vehicleLine.model);
    return models.includes(this.state.selectedModel)
      ? this.state.selectedModel
      : models[0];
  };

  fetchVehicleLines() {
    this.props.hideOrShow(true);
    VehicleCatalogClient.getNscVehicleLines(
      this.props.user,
      false,
      this.props.selectedMarket
    )
      .then((res) => {
        const selectedModel = this.getDefaultModel(res);
        const selectedYear = this.getYears(res, selectedModel);
        const catalogIds = res
          .filter(
            (x) =>
              x.model === selectedModel &&
              x.year.toString() === selectedYear.toString()
          )
          .map((model) => model.catalogId.toString());
        this.setState({
          selectedModel,
          selectedYear,
          modelData: res,
          catalogIds,
        });
      })
      .catch((error) => {
        logMsg("reason", error);
        if (isUnknownError(error)) {
          this.setState({ hasError: [PAGE_ERROR] });
        }
      })
      .finally(() => {
        this.fetchPreferencesForPriceChange(this.props.selectedMarket);
        this.props.hideOrShow(false);
      });
  }

  fetchPreferencesForPriceChange(market) {
    this.props.hideOrShow(true);
    PricingClient.getNscPreferenceForPriceChange(market, this.props.user)
      .then((res) => {
        this.setState({ preferences: res });
      })
      .catch((error) => {
        logMsg("reason", error);
        if (isUnknownError(error)) {
          this.setState({ hasError: [PAGE_ERROR] });
        }
      })
      .finally(() => {
        this.onCatalogChange();
        this.props.hideOrShow(false);
      });
  }

  isRowLocked(eventType) {
    return eventType === "isNewModel" || eventType === "tax";
  }

  getSubHeader = () => (
    <HasPermissionTo
      perform={["pricingAdministrationEdit"]}
      permissions={this.props.user.permissions.rolePermissions}
      render={() => (
        <SubNav
          {...this.props}
          title={this.props.t("PricingWrapper.priceEventAdministration")}
          listOfMarkets={MarketGroups(this.props.user.market)}
          updateMarket={this.onMarketChange}
          showCustomMarketDropdown={true}
          restrictDropdown={true}
          renderSubHeader={false}
        />
      )}
      noRender={() => (
        <SubNav
          {...this.props}
          title={this.props.t("PricingWrapper.priceEventAdministration")}
          showCustomMarketDropdown={false}
          restrictDropdown={true}
          renderSubHeader={false}
        />
      )}
    />
  );

  getYears = (data, selectedModel) => {
    const years =
      data &&
      data
        .filter((x) => x.model === selectedModel)
        .map((model) => model.year.toString());

    this.setState({
      yearDropDownValues: years,
    });

    return Math.max.apply(Math, years);
  };

  render() {
    let isSaveBtnEnabled = false;
    for (const name of Object.keys(this.eventTypeNames)) {
      if (
        this.state.optionsPriceEvent &&
        this.state.optionsPriceEvent[name].selectedIndex !==
          this.state.savedOptionsPriceEvent[name].selectedIndex
      )
        isSaveBtnEnabled = true;
    }

    if (displayError(this.state.hasError))
      throw new Error(this.state.hasError[0]);
    return (
      <div className="pageWrapper">
        <BackToButton
          backToUrl="/pricing"
          display={this.props.t("PricingWrapper.backToPricing")}
        />
        {this.getSubHeader()}

        <div className={eventStyles.tableContainer}>
          <DropDownContainer
            {...this.props}
            modelData={this.state.modelData}
            selectedModel={this.state.selectedModel}
            selectedTab={this.state.selectedTab}
            modelDropDownValues={this.state.modelDropDownValues}
            updateModel={this.onModelChange}
            yearValues={this.state.yearDropDownValues}
            updateYear={this.onYearChange}
            selectedYear={this.state.selectedYear}
          />
          {this.state.optionsPriceEvent && (
            <>
              <table className={eventStyles.eventTable}>
                <TableHeader {...this.props} />
                <tbody>
                  {Object.keys(this.state.optionsPriceEvent).map(
                    (type, index) => (
                      <tr key={`EventType - ${index}`}>
                        <td>{this.state.optionsPriceEvent[type].desc}</td>
                        {new Array(3).fill(0).map((_, optionIndex) => (
                          <TableCell
                            key={`radio-${optionIndex}`}
                            onChange={(event) =>
                              this.onPriceEventOptionChange(event, optionIndex)
                            }
                            isEmpty={this.isRowLocked(type)}
                            checked={
                              optionIndex + 1 ===
                              this.state.optionsPriceEvent[type].selectedIndex
                            }
                            disabled={
                              this.isRowLocked(type) ||
                              !this.props.user.permissions.rolePermissions.hasOwnProperty(
                                "pricingAdministrationEdit"
                              )
                            }
                            groupName={`${type}`}
                          />
                        ))}
                      </tr>
                    )
                  )}
                </tbody>
              </table>
              <div className={eventStyles.disclaimerContainer}>
                <p>{this.props.t("PricingWrapper.disclaimerHeader")}</p>
                <p>
                  {this.props.t("PricingWrapper.subDisclaimerHeader")}
                  <br></br>
                  {this.props.t("PricingWrapper.disclaimerDesc")}
                </p>
              </div>
              <button
                className={eventStyles.actionBtn}
                disabled={!isSaveBtnEnabled}
                onClick={this.onSaveChanges}
              >
                {this.props.t("PricingWrapper.savePricingEventAdministration")}
              </button>
              {this.state.updatedBy && (
                <p className={eventStyles.datestampText}>
                  {`Last updated by ${this.state.updatedBy} on ${this.state.updatedAt}`}
                </p>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation("emp")(EventAdministration);

/*

*/
